import {
  MAX_TRAVELLERS_IN_GROUP,
  MAX_CHILDREN_NUMBER,
  OPTIONAL_EXTRA_COVER_MAX,
} from '@/constants/products/travel';
import { toWordsOrdinal } from 'number-to-words';

const getAdultBirthLabel = (index) => {
  if (index === 1) {
    return 'What\'s your date of birth?';
  }

  return `What's the ${toWordsOrdinal(index)} traveller's date of birth?`;
};

const dateOfBirthChildrenSections = (() => {
  const sections = [];

  for (let i = 1; i <= MAX_CHILDREN_NUMBER; i++) {
    sections.push({
      sectionId: `date-of-birth-child_${i}`,
      sectionLabel: `What's the ${toWordsOrdinal(i)} child's date of birth?`,
      fields: [
        'dateOfBirthFamily',
      ],
    });
  }

  return sections;
})();

const dateOfBirthGroupSections = (() => {
  const sections = [];

  for (let i = 1; i <= MAX_TRAVELLERS_IN_GROUP; i++) {
    sections.push({
      sectionId: `date-of-birth-group_${i}`,
      sectionLabel: getAdultBirthLabel(i + 1),
      fields: [
        'dateOfBirthGroup',
      ],
    });
  }

  return sections;
})();

export const travelStructure = [
  {
    stepId: 'trip',
    stepLabel: 'Your Trip',
    groups: [
      {
        sections: [
          {
            sectionId: 'type-of-policy',
            sectionLabel: 'What type of cover do you need?',
            fields: [
              'typeOfPolicy',
            ],
          },
          {
            sectionId: 'destination-single',
            sectionLabel: 'Where are you off to?',
            fields: [
              'destination',
            ],
          },
          {
            sectionId: 'destination-annual',
            sectionLabel: 'Where are you off to?',
            fields: [
              'destination',
            ],
          },
          {
            sectionId: 'destination-backpacker',
            sectionLabel: 'Where are you off to?',
            fields: [
              'destination',
            ],
          },
          {
            sectionId: 'start-date',
            sectionLabel: 'What date would you like your cover to start?',
            fields: [
              'startDate',
            ],
          },
          {
            sectionId: 'end-date',
            sectionLabel: 'What date would you like your cover to end?',
            fields: [
              'endDate',
            ],
          },
          {
            sectionId: 'backpacker-traveling',
            sectionLabel: 'How many months do you expect to be travelling?',
            fields: [
              'travellingMonths',
            ],
          },
          {
            sectionId: 'cover',
            sectionLabel: 'Would you like to add cover for any of the following?',
            fields: [
              'gadgetCover',
              'cruiseCover',
              'winterSportsCover',
            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'travellers',
    stepLabel: 'The Travellers',
    groups: [
      {
        sections: [
          {
            sectionId: 'type-of-party',
            sectionLabel: 'Who is the cover for?',
            fields: ['typeOfParty'],
          },
          {
            sectionId: 'people-adults-traveling',
            sectionLabel: 'Number of adults travelling?',
            fields: [
              'travellingAdults',
            ],
          },
          {
            sectionId: 'people-children-traveling',
            sectionLabel: 'Number of children travelling?',
            fields: ['travellingChildren'],
          },
          {
            sectionId: 'people-group-traveling',
            sectionLabel: 'How many people will be covered under this policy?',
            fields: [
              'travellingPeople',
            ],
          },
          {
            sectionId: 'date-of-birth',
            sectionLabel: 'What\'s your date of birth?',
            fields: [
              'dateOfBirth',
            ],
          },
          {
            sectionId: 'couple-date-of-birth',
            sectionLabel: 'What\'s your partner\'s date of birth?',
            fields: [
              'dateOfBirthAdult_2',
            ],
          },
          {
            sectionId: 'family-adult',
            sectionLabel: 'What\'s your partner\'s date of birth?',
            fields: [
              'dateOfBirthFamily',
            ],
          },
        ],
      },
      {
        sections: dateOfBirthChildrenSections,
      },
      {
        sections: dateOfBirthGroupSections,
      },
      {
        sections: [
          {
            sectionId: 'title',
            sectionLabel: 'What is your title?',
            fields: ['title'],
          },
          {
            sectionId: 'name',
            sectionLabel: 'What is your name?',
            fields: [
              'firstName',
              'surname',
            ],
          },
          {
            sectionId: 'email',
            sectionLabel: 'Email address',
            fields: ['email'],
          },
          {
            sectionId: 'direct-marketing-options',
            sectionLabel: 'Marketing options',
            fields: [
              'directMarketingEmail',
              'directMarketingSms',
              'directMarketingPost',
              'directMarketingPhone',
            ],
          },
          {
            sectionId: 'user-data',
            sectionLabel: 'Account details',
            fields: ['userData', 'userDataConfirm', 'userLoginEmail', 'userLoginPassword', 'userLoginOneTimePassword'],
          },
        ],
      },
    ],
  },
];

export const convertExtraCover = (coverAmount) => {
  const moreThanMax = coverAmount >= OPTIONAL_EXTRA_COVER_MAX;

  const formattedBigCoverAmount = `${coverAmount / OPTIONAL_EXTRA_COVER_MAX}m`;

  const formattedSmallCoverAmount = (coverAmount !== Math.floor(coverAmount)
    ? coverAmount.toFixed(2)
    : coverAmount.toLocaleString());

  return moreThanMax ? formattedBigCoverAmount : formattedSmallCoverAmount;
};
